import type { State } from '../types';

export const selectSessionId = (state: State) => state.sessionId;
